import { Component, Vue } from 'vue-property-decorator';
import { request } from '@/tools/request';
import LogoBar from '@/components/LogoBar/LogoBar'
import WorldMap from '@/components/WorldMap/WorldMap'
import WorldMapHeat from '@/components/WorldMapHeat/WorldMapHeat'

@Component<VerifiedViews>({
  components: {
    WorldMap,
    WorldMapHeat,
    LogoBar,
  },
  filters: {
    trimString(string: string) {
      return `${string.substring(0, 7)}..`;
    }
  }
})
export default class VerifiedViews extends Vue {
  protected baseUrl: string = process.env.VUE_APP_API_BASE_ENDPOINT || 'https://us-central1-api-solution.cloudfunctions.net/webApi/api/v1/';
  protected viewsUrl: string = this.baseUrl + 'views';
  protected isScrolled: boolean = false;
  protected heatMapData: any = [
    ['Country',   'Views'],
  ];
  protected mapMarkers: any = [];
  protected getTimestamp: number = 0;
  protected headers: any = [
    {
      text: 'ARTIST',
      align: 'left',
      sortable: false,
      value: 'name',
    },
    { text: 'DATE', value: 'time', sortable: false, },
    { text: 'TIME', value: 'time', sortable: false, },
    { text: 'LOCATION', value: 'gps', sortable: false, },
    { text: 'FILE NAME', value: 'file_name', sortable: false, },
    { text: 'CERTIFICATE', value: 'certificate', sortable: false, },
    { text: 'PAYMENT', value: 'payment_token', sortable: false, },
  ];
  protected totalViews: any = [];
  protected vrViews: any = [];
  protected arViews: any = [];
  protected clientViews: any = [];

  public mounted() {
    this.getViews();
    this.getWorldMapData();
  }

  public created() {
    window.addEventListener('scroll', this.checkScroll);
  }

  public destroyed() {
    window.removeEventListener('scroll', this.checkScroll);
  }

  protected getCertificateTokenString(certs: any) {
    return certs === undefined ? '' : certs[0].hash;
  }

  protected getPaymentTokenString(url: any) {
    return url.substring(url.lastIndexOf('/') + 1);
  }

  protected setMapData() {
    this.totalViews.forEach((view: any) => {
      if (view.location && view.location.lon && view.location.lat) {
        let marker: any = {
          center: {
            lat: view.location.lat === typeof 'string' ? view.location.lat : Number(view.location.lat),
            lng: view.location.lon === typeof 'string' ? view.location.lon : Number(view.location.lon),
          },
          timestamp: view.timestamp,
          band: view.band,
          video: view.video_title,
          source: view.source ? view.source : '',
          // certToken: view.certifications ? view.certifications[0].hash : '-',
          gps: view.location ? `${view.location.lat} / ${view.location.lon}` : '-',
          id: view.id,
          payment_token: view.payment_token || '-'
        }

        if (view.certifications.length && view.certifications[0].uri) {
          marker['certificate'] = view.certifications[0].uri;
        } else {
          marker['certificate'] = '-';
        }

        if (view.certifications.length && view.certifications[0].hash) {
          marker['certToken'] = view.certifications[0].hash;
        } else {
          marker['certToken'] = '-';
        }
        
        this.mapMarkers.push(marker);
      }
    });
  }

  protected parseUnixToTime(unix: any) {
    const date = new Date(unix * 1000);
    const minutes = "0" + date.getMinutes();
    const formattedTime = `${date.getHours()}:${minutes.substr(-2)}`;
    return formattedTime;
  }

  protected parseUnixToDate(unix: any) {
    const date = new Date(unix * 1000);
    const formattedlDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    return formattedlDate;
  }

  protected getLocation(city: any, country: any) {
    if (city && country) return `${city}, ${country}`;
    else if (country) return `${country} `;
    else if (city) return `${city} `;
    else return '-';
  }

  protected checkScroll() {
    const scrollObject = {
      y: window.pageYOffset
    }

    if (scrollObject.y > 30) this.isScrolled = true;
    if (scrollObject.y < 30) this.isScrolled = false;
  }

  protected getWorldMapData() {
    let encrypt: boolean = true;

    request('get', `${this.baseUrl}aggregatedData`, encrypt).then(
      (response: any) => {
        if (response.data) {
          this.parseWorldMapData(response.data);
        }
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

  protected parseWorldMapData(data: any) {
    let worldMapAray: any = [
      ['Country',   'Views'],
    ];
    Object.keys(data).forEach(function(key: any, index: any) {
      worldMapAray.push([
        key,
        data[key],
      ]);
    });
    this.heatMapData = worldMapAray;
  }

  protected getViews() {
    let encrypt: boolean = true
    // TODO: Can use query parameters to filter. Might be faster
    request('get', this.viewsUrl, encrypt)
      .then((response: any) => {
        this.vrViews = [];
        this.arViews = [];
        this.clientViews = [];
        this.totalViews = [];

        response.data.forEach((e: any, index: any) => {
          const view = e.data;
          const viewWithId: any = {
            ...view,
            id: e.id,
          }

          this.totalViews.push(viewWithId);
            if (view.source === 'vr') {
              this.vrViews.push(view);
            }
            if (view.source === 'ar') {
              this.arViews.push(view);
            }
            if (view.source === 'client') {
              this.clientViews.push(view);
            }
        });
        this.sortViewData();
        this.setMapData();
        this.getTimestamp = Math.floor(Date.now() / 1000);
        setInterval(() => {
          this.getNewViews();
        }, 20000);
      });
  }

  protected getNewViews() {
    let encrypt: boolean = true;
    
    request('get', this.viewsUrl + '?timestamp=' + this.getTimestamp, encrypt)
      .then((response: any) => {
        if (!response.data) return;
        response.data.forEach((view: any) => {
          this.getTimestamp = Math.floor(Date.now() / 1000);
          if (view.source === 'vr') {
            this.vrViews.unshift(view);
          }
          if (view.source === 'ar') {
            this.arViews.unshift(view);
          }
          if (view.source === 'client') {
            this.clientViews.unshift(view);
          }
        });
        this.getTimestamp = Math.floor(Date.now() / 1000);
      },
        (error: any) => {
          console.log('request error', error);
        }
      );
  }

  protected sortViewData() {
    this.arViews = this.arViews.sort(this.sortNumber);
    this.vrViews = this.vrViews.sort(this.sortNumber);
    this.clientViews = this.clientViews.sort(this.sortNumber);
  }

  protected sortNumber(a: any, b: any) {
    return b.timestamp - a.timestamp;
  }

}

interface Marker {
  center: any;
  plays: number;
}
